import React, { useContext } from 'react';
import { NfcCardsContext, INfcCardsContext } from '../../../nfcCardsState/nfcCardsContext';
import { AddNewBlockButton } from './components/AddNewBlockButton';
import { NfcCardsFields } from './components/NfcCardsFields/NfcCardsFields';
import style from './NfcCardsBlock.module.scss';

export const NfcCardsBlock: React.FC = () => {
	const { addNfcCardsBlock, deleteNfcCardsBlock, changeUUIDCard, changeFullName, changeNfcCardPermission, nfcCards } =
		useContext<INfcCardsContext>(NfcCardsContext);

	return (
		<div className={style.container}>
			{nfcCards.length ? (
				nfcCards.map((el, i) => (
					<NfcCardsFields
						key={el.id}
						settingsId={el.id}
						isLastBlock={i >= 29}
						changeUUIDCard={changeUUIDCard}
						changeFullName={changeFullName}
						changeNfcCardPermission={changeNfcCardPermission}
						deleteNfcCardsBlock={deleteNfcCardsBlock}
					/>
				))
			) : (
				<div className={style.divider} />
			)}
			{nfcCards.length < 30 && <AddNewBlockButton addNfcCardsBlock={addNfcCardsBlock} />}
		</div>
	);
};
